import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";

export default function HotRanking() {
  const ranked = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最受欢迎的韩国漫画</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {ranked.map((comic, index) => (
            <ComicCard key={comic.id} comic={comic} showRank rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}